<div class="flex min-w-0 flex-auto flex-col">
  <!-- Header -->
  <div class="bg-card">
    <div class="mx-auto flex w-full max-w-screen-xl flex-col px-6 sm:px-8">
      <div
        class="my-8 flex min-w-0 flex-auto flex-col sm:my-12 sm:flex-row sm:items-center">
        <!-- Avatar and name -->
        <div class="flex min-w-0 flex-auto items-center">
          <div class="h-16 w-16 flex-0 overflow-hidden rounded-full">
            <img
              class="h-full w-full object-cover"
              src="images/avatars/brian-hughes.jpg" />
          </div>
          <div class="ml-4 flex min-w-0 flex-col">
            <ng-container *transloco="let t">
              <div
                class="truncate text-2xl font-semibold leading-7 tracking-tight md:text-5xl md:leading-snug">
                {{ 'WelcomeBack' | transloco }}, {{authService.user?.Name}}
              </div>
            </ng-container>
          </div>
        </div>
      </div>
      <!-- Project selector -->
      <div
        class="bg-default relative flex cursor-pointer self-start overflow-hidden rounded-t-xl border border-b-0 pb-1 pl-5 pr-4 pt-2"
        matRipple>
        <div class="flex items-center">
          <div class="overflow-hidden">
            <div class="truncate font-medium leading-6">
              {{'PurchaseOverview' | transloco}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Main -->
  <div class="-mt-px flex-auto border-t pt-4 sm:pt-6">
    <div class="mx-auto w-full max-w-screen-xl">
      <!-- Tabs -->
      <mat-tab-group
        class="sm:px-2"
        mat-stretch-tabs="false"
        ranimationDuration]="'0'"
        r(selectedIndex)]="selectedTabIndex">
        <!-- Summary -->
        <mat-tab rlabel]="'Summary' | transloco">
          <ng-template matTabContent>

            @if(data()?.vehicleStock) {
            <app-vehicle-stock rdata]="data().vehicleStock"
              rrange]="vehicleStockPeriod"></app-vehicle-stock>
            }

            <div class="grid grid-cols-1 md:grid-cols-2 mt-6 gap-8 max-w-full">

              <app-upcoming-vehicles></app-upcoming-vehicles>

              <app-trade-in-vehicles></app-trade-in-vehicles>
            </div>
          </ng-template>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
</div>


